module.exports = __webpack_public_path__ + "img/usergroup-add.323d4eae.svg";